var map = {
	"./21_lfu_teams": "0bab",
	"./21_lfu_teams.json": "0bab",
	"./22_lfu_teams": "154b",
	"./22_lfu_teams.json": "154b",
	"./22_lpk_1_teams": "b581",
	"./22_lpk_1_teams.json": "b581",
	"./DEM_Black_PNG.png": "2e2b",
	"./DEM_White_PNG.png": "17df",
	"./amazonas.png": "0c2b",
	"./android.png": "e00f",
	"./android_1.jpg": "6076",
	"./android_2.jpg": "c685",
	"./android_3.jpg": "55f5",
	"./android_4.jpg": "74f3",
	"./bg_1.jpg": "9dac",
	"./bg_2.jpg": "94ff",
	"./bg_3.jpg": "51ee",
	"./bg_4.jpg": "821b",
	"./bg_5.jpg": "a22f",
	"./bg_6.jpg": "35a8",
	"./df-logo.png": "b4a7",
	"./fieras.png": "fcff",
	"./furia.png": "ac7d",
	"./ios_1.png": "95d9",
	"./ios_2.png": "828b",
	"./ios_3.png": "712c",
	"./ios_4.png": "653b",
	"./iphone.png": "c4cb",
	"./karma.png": "0fc2",
	"./lfu.png": "9488",
	"./logo.png": "cf05",
	"./main-bg.png": "5a4a",
	"./musas.png": "f01d",
	"./wakanda.png": "4dc9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";